import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { singleReservationAction } from '../../../redux/actions/reservationActions';
import Humberg from '../../../elements/Humberg';
import Loader from '../../loader/loader';
import { getCountdown } from '../../../utils/Countdown';
import OrderForm from './OrderForm';
import { CREATE_ORDER_RESET } from '../../../redux/constants/orderConstants';
import { clearErrors } from '../../../redux/actions/userActions';


const CreateOrder = () => {


    const dispatch = useDispatch()
    const navigate=useNavigate()


    const { loading, reservation } = useSelector(state => state.singleReservation)
    const { loading: createOrderLoading, error, message } = useSelector(state => state.order)



    const [isExpired, setIsExpired] = useState(false);

    const [searchParams] = useSearchParams()
    const reservation_id = searchParams.get("reservation_id");


    const [showPopup, setShowPopup] = useState(false);



    useEffect(() => {
        if (reservation?.expires_at) {
            const now = new Date();
            const expiryDate = new Date(reservation.expires_at);

            setIsExpired(now > expiryDate);
        }
    }, [reservation]);


    useEffect(() => {
        if (reservation_id) {
            dispatch(singleReservationAction(reservation_id))
        }

    }, [reservation_id, dispatch])



    useEffect(() => {



        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("orders")


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Create Order`;

        console.log(reservation?.status)



    }, [reservation]);

    // Remove one quantity



    const [timeLeft, setTimeLeft] = useState(
        getCountdown(reservation?.expires_at)
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown(reservation?.expires_at));

            const now = new Date().getTime();
            const expiry = new Date(reservation?.expires_at).getTime();

            if (now >= expiry) {
                setIsExpired(true);
            }


        }, 1000);

        return () => clearInterval(interval);
    }, [reservation?.expires_at]);



    useEffect(() => {


        if (error) {
            setShowPopup(true)
        }

        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
            navigate("/orders/all-orders")
        }

    }, [error, message, dispatch,navigate])



    const handleClosePopup = () => {
        setShowPopup(false)
        dispatch(clearErrors())
    }

    



    return (
        <Fragment>
            {(loading || createOrderLoading) && <Loader />}
            <Humberg header="Orders" headerLink="/orders/all-orders" children={"Create Order"} />
            <section className="p-[1.5vmax] pt-[0.5vmax]">
                {(isExpired || !reservation || reservation?.status !== "ACTIVE") ?
                    <div className="bg-white p-[4vmax_2vmax] shadow-1 rounded-xl ">
                        <h2 className="text-[1.8vmax]  pb-[0.2vmax]  font-3 font-[800] mx-auto w-fit mb-[1vmax] text-red-500" > Reservation No Longer Valid</h2>
                        <p className='w-[60%] mx-auto text-center text-[1.2vmax]' >
                            This reservation is no longer active due to expiration or cancellation.
                            Kindly create a new reservation in order to continue with the order process.
                        </p>
                        <div className="flex-center mt-[1vmax]">

                            <Link to={'/products/all-products'} className="mx-auto text-white bg-[image:var(--gradient-2)] p-[0.7vmax_1.5vmax] rounded-[2vmax]">
                                Reserve Product
                            </Link>

                        </div>
                    </div>
                    :
                    <div className="bg-white p-[2vmax] shadow-1 rounded-xl">
                        <div className="flex justify-between">
                            <OrderForm reservation={reservation} timeLeft={timeLeft} />
                        </div>
                    </div>
                }
            </section>
            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 rounded-full bg-red-50 text-red-600 flex-center text-2xl mb-4">
                            <i className="fa-solid fa-circle-exclamation"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                Order Creation Error
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed">
                                {error}
                            </p>
                        </div>

                        {/* Button */}
                        <div className="flex justify-center mt-6">
                            <button
                                className="w-full bg-gradient-to-r from-red-600 to-red-700 text-white font-semibold py-2.5 px-4 rounded-xl hover:shadow-lg hover:shadow-red-100 transition-all active:scale-[0.98]"
                                onClick={() => handleClosePopup()}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default CreateOrder